// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__1JYxk","buttons":"Settings_buttons__1Vtsf","tabs":"Settings_tabs__3qUvw"};